import {
  CHANGE_CURRENT_SCREEN,
  CHANGE_SEARCH_TERM,
  DISPLAY_SIDEBAR
} from '@/state/mutationTypes'

export const globalTrackingStore = {
  namespaced: true,
  state: {
    searchTerm: '',
    isMainPage: false,
    currentScreen: '',
    isActive: true
  },
  mutations: {
    [CHANGE_SEARCH_TERM](state, searchTerm) {
      state.searchTerm = searchTerm
    },
    [CHANGE_CURRENT_SCREEN](state, screen) {
      state.currentScreen = screen
    },
    [DISPLAY_SIDEBAR](state) {
      state.isActive = !state.isActive
    }
  },
  actions: {
    changeSearchTerm({ commit }, searchTerm) {
      commit(CHANGE_SEARCH_TERM, searchTerm)
    },
    changeCurrentScreen({ commit }, screen) {
      commit(CHANGE_CURRENT_SCREEN, screen)
    },
    displaySideBar({ commit }) {
      commit(DISPLAY_SIDEBAR)
    }
  }
}
